<div class="airdrop" [ngClass]="httpService.theme">
    <div class="w-100 mb-5 outer-box first">
        <div class="right d-flex flex-column gap-3">
            <div class="top p-3 font_xl bold gradient">
                Collect Moons for $CRED airdrops
            </div>
            <div class="bottom p-3">
                <div class="mb-4 one">
                    <div class="d-grid align-items-center justify-content-start">
                        <div class="color d-flex gap-2">
                            <span class="total-moons">{{ total_user_moon | number: '0.0-0' }}</span>
                            <img [width]="30" src="https://assets.credible.finance/IMG312.png" alt="" />
                        </div>
                        <div class="mb-2" style="color: grey;">Moons Earned</div>
                    </div>
                    <div class="font">
                        <div class="text-left">
                            Complete tasks to qualify for $CRED airdrops!
                        </div>
                    </div>
                </div>
                <div class="progress-container mb-3">
                    <div class="progress-bar" [style.width.%]="progress"></div>
                </div>
                <div class="d-flex mb-4 font gap-2">
                    <div class="task-completed font bold_xl">
                        {{ completed_task_count }}/{{ total_task_count }}
                    </div>
                    <div>Tasks Completed</div>
                </div>
                <div class="w-100">
                    <cf-button theme="dark" label="Learn about Airdrop" (clicked)="
                            redirectUrl(
                                'https://crediblefinance.notion.site/airdrop'
                            )
                        " type="text">
                    </cf-button>
                </div>
            </div>
        </div>
    </div>

    <div id="joinSocialMedia-google-recaptcha"></div>

    <div class="w-100 second mb-5">
        <div class="font_l bold mb-3">Tasks to get Moons</div>

        <div class="grid w-100" *ngIf="non_multiplier_tasks.length > 0">
            <cf-card [theme]="httpService.theme" type="empty" *ngFor="let task of non_multiplier_tasks">
                <app-airdrop-buy-node [task]="task" *ngIf="task.id === 'buy_node'"></app-airdrop-buy-node>
                <app-airdrop-connect-wallet [task]="task"
                    *ngIf="task.id === 'connect_wallet'"></app-airdrop-connect-wallet>
                <app-airdrop-credit-score [task]="task" *ngIf="task.id === 'credit_score'"></app-airdrop-credit-score>
                <app-airdrop-discord [task]="task" *ngIf="task.id === 'discord'"></app-airdrop-discord>
                <app-airdrop-telegram [task]="task" *ngIf="task.id === 'telegram'"></app-airdrop-telegram>
                <app-airdrop-twitter [task]="task" *ngIf="task.id === 'twitter'"></app-airdrop-twitter>
                <app-airdrop-kyc [task]="task" *ngIf="task.id === 'kyc'"></app-airdrop-kyc>
                <app-airdrop-lend [task]="task" *ngIf="task.id === 'lend_pusd'"></app-airdrop-lend>
                <app-airdrop-share-on-twitter [task]="task"
                    *ngIf="task.id === 'share_on_twitter'"></app-airdrop-share-on-twitter>
                <app-airdrop-referral [task]="task" *ngIf="task.id === 'referral'"
                    [referred_user_count]="referred_user_count"></app-airdrop-referral>
            </cf-card>
        </div>
    </div>
    <div class="w-100 third pt-5">
        <div class="text-center mb-5">
            <div class="font_l bold mb-4">Frequently Asked Questions</div>
            <div class="desc_color text-center font">
                Do you have any questions? Here are some frequently asked
                questions that we have answered
            </div>
        </div>
        <div class="faq_questions pt-3" *ngIf="questions.length > 0">
            <div class="box" *ngFor="let item of questions; index as i">
                <!-- <div> -->
                <div *ngIf="!item.open" class="one mb-2 d-flex justify-content-between" (click)="openQues(i)">
                    <span class="questions bold">
                        {{ item.q }}
                    </span>
                    <span>
                        <i class="fa-solid fa-plus" *ngIf="!item.open" (click)="openQues(i)"></i>
                    </span>
                </div>
                <div *ngIf="item.open" class="one mb-2 d-flex justify-content-between" (click)="closeQues(i)">
                    <span class="questions bold">
                        {{ item.q }}
                    </span>
                    <span>
                        <i class="fa-solid fa-minus" *ngIf="item.open" (click)="closeQues(i)"></i>
                    </span>
                </div>
                <div *ngIf="item.open" class="two">
                    <ul *ngIf="item.hasBullets">
                        <li class="answers font_lg desc_color" *ngFor="let answer of item.a">
                            {{ answer }}
                        </li>
                    </ul>
                    <p *ngIf="!item.hasBullets" class="font_lg desc_color answers">
                        {{ item.a }}
                    </p>
                </div>
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>